<div
  class="flex flex-col items-center justify-center size-20 p-3 rounded-(--timebadge-border-radius) bg-(--timebadge-background)"
>
  <app-dynamic
    componentName="DynamicText"
    [props]="{ config: timeTextConfig() }"
  />
  <app-dynamic
    componentName="DynamicText"
    [props]="{ config: labelTextConfig() }"
  />
</div>
